import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ez-table-zero-match-state__content" }
const _hoisted_2 = { class: "ez-table-zero-match-state__message" }
const _hoisted_3 = {
  key: 0,
  class: "ez-table-zero-match-state__description"
}

import { computed } from 'vue';
import { i18n } from '@/i18n';

interface Props {
  /** ゼロマッチメッセージ */
  message?: string;
  /** 説明文（省略可） */
  description?: string;
  /** カスタムCSSクラス（省略可） */
  customClass?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EzTableZeroMatchState',
  props: {
    message: { default: '' },
    description: { default: '' },
    customClass: { default: '' }
  },
  setup(__props: any) {

const t = i18n.t;

/**
 * EzTableのゼロマッチ状態表示コンポーネント
 * 検索結果が0件の場合や、データが存在しない場合の表示を行う
 */

/**
 * Props定義
 */
const props = __props;

/**
 * 表示するメッセージを取得
 */
const displayMessage = computed(() => {
  return props.message || t('該当するデータはありません');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['ez-table-zero-match-state', _ctx.customClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"ez-table-zero-match-state__icon\" data-v-453c3492><svg width=\"64\" height=\"64\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-453c3492><rect x=\"3\" y=\"5\" width=\"18\" height=\"14\" rx=\"2\" stroke=\"#9e9e9e\" stroke-width=\"1.5\" fill=\"none\" data-v-453c3492></rect><line x1=\"3\" y1=\"9\" x2=\"21\" y2=\"9\" stroke=\"#9e9e9e\" stroke-width=\"1.5\" data-v-453c3492></line><circle cx=\"12\" cy=\"14\" r=\"2\" stroke=\"#9e9e9e\" stroke-width=\"1.5\" fill=\"none\" data-v-453c3492></circle><path d=\"M12 14v-1M12 14v1\" stroke=\"#9e9e9e\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-453c3492></path></svg></div>", 1)),
      _createElementVNode("div", _hoisted_2, _toDisplayString(displayMessage.value), 1),
      (_ctx.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})